[
    {
        "inputs":  [
                       {
                           "internalType":  "address",
                           "name":  "_reputationRegistry",
                           "type":  "address"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_subnameRegistrar",
                           "type":  "address"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_allowedRouter",
                           "type":  "address"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_feeRecipient",
                           "type":  "address"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_protocolFeeBps",
                           "type":  "uint256"
                       }
                   ],
        "stateMutability":  "nonpayable",
        "type":  "constructor"
    },
    {
        "inputs":  [

                   ],
        "name":  "DealIdMismatch",
        "type":  "error"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "uint256",
                           "name":  "provided",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "maximum",
                           "type":  "uint256"
                       }
                   ],
        "name":  "FeeBpsTooHigh",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "InvalidFeeRecipient",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ZeroReputationRegistry",
        "type":  "error"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "seller",
                           "type":  "address"
                       },
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "escrow",
                           "type":  "address"
                       },
                       {
                           "indexed":  true,
                           "internalType":  "uint256",
                           "name":  "dealId",
                           "type":  "uint256"
                       }
                   ],
        "name":  "HandOffCreated",
        "type":  "event"
    },
    {
        "inputs":  [

                   ],
        "name":  "ALLOWED_ROUTER",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "FEE_RECIPIENT",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "PROTOCOL_FEE_BPS",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "REPUTATION_REGISTRY",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "SUBNAME_REGISTRAR",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "address",
                           "name":  "_payoutToken",
                           "type":  "address"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_amount",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_expirationWindow",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "string",
                           "name":  "_sellerEns",
                           "type":  "string"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_sellerPayoutAddress",
                           "type":  "address"
                       }
                   ],
        "name":  "createHandOff",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "escrow",
                            "type":  "address"
                        },
                        {
                            "internalType":  "uint256",
                            "name":  "dealId",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "nonpayable",
        "type":  "function"
    }
]
